import { call, put, takeLatest } from 'redux-saga/effects';

import { getVendorFieldsVisibilityEffect } from '../POV/POVEffects';
import {
  setGetPaymentTypes,
  setLinerCodes,
  setMeasurementUnits,
  setPricingBasis,
  setPricingTypes,
  setTaxTypes,
  setVendorFieldsVisibility,
} from './LookupsActions';
import {
  getLinerCodesEffects,
  getMeasurementUnitsEffects,
  getPaymentTypesEffects,
  getPricingBasisEffects,
  getPricingTypesEffects,
  getTaxTypesEffects,
} from './LookupsEffects';
import LookupsTypes from './LookupsTypes';

function* getTaxTypesWatcher() {
  try {
    const { data } = yield call(getTaxTypesEffects);
    yield put(setTaxTypes(data));
  } catch {
    yield put(setTaxTypes([]));
  }
}

function* getPricingBasisWatcher() {
  try {
    const { data } = yield call(getPricingBasisEffects);
    yield put(setPricingBasis(data));
  } catch (error) {
    console.log(error);
    yield put(setPricingBasis([]));
  }
}

function* getPricingTypesWatcher() {
  try {
    const { data } = yield call(getPricingTypesEffects);
    yield put(setPricingTypes(data));
  } catch (error) {
    console.log(error);
    yield put(setPricingTypes([]));
  }
}

function* getMeasurementUnitsWatcher() {
  try {
    const { data } = yield call(getMeasurementUnitsEffects);
    yield put(setMeasurementUnits(data));
  } catch {
    yield put(setMeasurementUnits([]));
  }
}

function* getLinerCodesWatcher() {
  try {
    const { data } = yield call(getLinerCodesEffects);
    yield put(setLinerCodes(data));
  } catch {
    yield put(setLinerCodes([]));
  }
}

function* getPaymentTypesWatcher({ payload }) {
  try {
    const { data } = yield call(getPaymentTypesEffects, payload);
    yield put(setGetPaymentTypes(data));
  } catch {
    yield put(setGetPaymentTypes([]));
  }
}

function* getVendorFieldsVisibilityWatcher() {
  try {
    const { data } = yield call(getVendorFieldsVisibilityEffect);
    yield put(setVendorFieldsVisibility(Object.fromEntries(data.map((item) => [item.columnName, item.isVisible]))));
  } catch {
    yield put(setVendorFieldsVisibility([]));
  }
}

export default function* LookupsSaga() {
  yield takeLatest(LookupsTypes.GET_TAX_TYPES_TYPES, getTaxTypesWatcher);
  yield takeLatest(LookupsTypes.GET_PRICING_BASIS, getPricingBasisWatcher);
  yield takeLatest(LookupsTypes.GET_PRICING_TYPES, getPricingTypesWatcher);
  yield takeLatest(LookupsTypes.GET_MEASUREMENT_UNIT_TYPES, getMeasurementUnitsWatcher);
  yield takeLatest(LookupsTypes.GET_LINER_CODES, getLinerCodesWatcher);
  yield takeLatest(LookupsTypes.GET_PAYMENT_TYPES, getPaymentTypesWatcher);
  yield takeLatest(LookupsTypes.GET_VENDOR_FIELDS_VISIBILITY, getVendorFieldsVisibilityWatcher);
}
